import { 
    collection, 
    onSnapshot, 
    query, 
    orderBy,
    db 
} from '@core/firebase';
import React, { useEffect, useReducer } from 'react';


import { useAuth } from './AuthContext';
import { InventoryContext } from './InventoryContext';

const initialState = {
    products: [],
    loading: true,
    error: null
};

function inventoryReducer(state, action) {
    switch (action.type) {
        case 'SYNC_START':
            return { ...state, loading: true, error: null };
        case 'SYNC_SUCCESS':
            return { ...state, products: action.payload, loading: false, error: null };
        case 'SYNC_ERROR':
            return { ...state, loading: false, error: action.payload };
        case 'RESET':
            return { ...initialState, loading: false };
        default:
            return state;
    }
}

/**
 * InventoryProvider - Centralized inventory synchronization.
 * Holds the main "onSnapshot" listener for the entire app.
 */
export const InventoryProvider = ({ children }) => {
    const [state, dispatch] = useReducer(inventoryReducer, initialState);
    const { user } = useAuth();

    useEffect(() => {
        // Only sync if we have a user (standard or anonymous)
        if (!user) {
            dispatch({ type: 'RESET' });
            return;
        }

        dispatch({ type: 'SYNC_START' });

        // Single real-time listener for the collection
        const q = query(collection(db, 'inventory'), orderBy('description', 'asc'));
        
        const unsubscribe = onSnapshot(q, (snapshot) => {
            const items = snapshot.docs
                .map(doc => ({ 
                    id: doc.id, 
                    ...doc.data() 
                }))
                .filter(item => item.status !== 'ARCHIVED');
            
            dispatch({ type: 'SYNC_SUCCESS', payload: items });
        }, (err) => {
            console.error("Critical Inventory Sync Error:", err);
            let msg = err.message;
            if (err.code === 'permission-denied') {
                msg = "PERMISSION_DENIED: Esta terminal no tiene autorización para leer el inventario.";
            }
            dispatch({ type: 'SYNC_ERROR', payload: msg });
        });

        return () => unsubscribe();
    }, [user]);

    const value = {
        products: state.products,
        loading: state.loading,
        error: state.error
    };

    return (
        <InventoryContext.Provider value={value}>
            {children}
        </InventoryContext.Provider>
    );
};
